import React, { PureComponent } from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import classNames from "classnames";
import i18n from "i18next";

import { paginateResults } from "../../../helpers/listHelpers";
import CustomerTile from "./Tiles/CustomerTile";
import MillOrdersTile from "./Tiles/MillOrdersTile";
import PurchaseOrderTile from "./Tiles/PurchaseOrderTile";
import SearchNoResult from "./SearchNoResult";
import ShipmentsTile from "./Tiles/ShipmentsTile";

class SearchResultsTable extends PureComponent {
  static propTypes = {
    PaginationComponent: PropTypes.func.isRequired,
    onChangePagination: PropTypes.func.isRequired,
    onShowAllMillOrder: PropTypes.func.isRequired,
    onShowAllShipment: PropTypes.func.isRequired,
    currentPage: PropTypes.number,
    isMobile: PropTypes.bool,
    itemsByPage: PropTypes.number,
    itemsWithAllMillOrderShown: PropTypes.array,
    itemsWithAllShipmentShown: PropTypes.array,
    results: PropTypes.array,
    searchFieldValue: PropTypes.string,
    userMetadata: PropTypes.object,
    values: PropTypes.object
  };

  static defaultProps = {
    itemsWithAllMillOrderShown: [],
    itemsWithAllShipmentShown: [],
    currentPage: 1,
    isMobile: false,
    itemsByPage: 100,
    results: [],
    searchFieldValue: "",
    userMetadata: {},
    values: {}
  };

  get firstElement() {
    return (this.props.currentPage - 1) * this.props.itemsByPage;
  }

  get lastElement() {
    return this.props.currentPage * this.props.itemsByPage;
  }

  get dataCount() {
    return _.size(this.props.results);
  }

  get isResultEmpty() {
    return _.isEmpty(this.props.results);
  }

  handleNextPage = dataCount => {
    if (this.lastElement < dataCount) {
      this.advancedSearchContainerRef.current.scrollLeft = 0;
      this.props.onChangePagination(this.props.currentPage + 1);
    }
  };

  handlePreviousPage = () => {
    if (this.props.currentPage !== 1) {
      this.advancedSearchContainerRef.current.scrollLeft = 0;
      this.props.onChangePagination(this.props.currentPage - 1);
    }
  };

  advancedSearchContainerRef = React.createRef();

  render() {
    const { isMobile, onShowAllMillOrder, onShowAllShipment, PaginationComponent } = this.props;
    const { searchField = "", searchQuery = "" } = this.props.values;
    const paginatedResults = paginateResults(this.props.results, this.firstElement, this.lastElement);

    return (
      <div className="advanced-search__container" ref={this.advancedSearchContainerRef}>
        <section className={classNames("advanced-search", this.isResultEmpty && "--no-result")}>
          <span className="advanced-search__title">
            {i18n.t("advancedSearch.resultsFor")} {this.props.searchFieldValue} # {searchQuery}
          </span>

          {this.isResultEmpty && <SearchNoResult />}

          {!this.isResultEmpty &&
            paginatedResults.map(result => (
              <div className="advanced-search__tile-row" key={result.id}>
                <PurchaseOrderTile searchQuery={searchQuery} searchField={searchField} result={result} />
                <CustomerTile searchQuery={searchQuery} searchField={searchField} result={result} />
                <MillOrdersTile
                  itemsWithAllMillOrderShown={this.props.itemsWithAllMillOrderShown}
                  onShowAllMillOrder={onShowAllMillOrder}
                  searchQuery={searchQuery}
                  searchField={searchField}
                  result={result}
                />
                <ShipmentsTile
                  isMobile={isMobile}
                  itemsWithAllShipmentShown={this.props.itemsWithAllShipmentShown}
                  onShowAllShipment={onShowAllShipment}
                  searchQuery={searchQuery}
                  searchField={searchField}
                  result={result}
                  userMetadata={this.props.userMetadata}
                />
              </div>
            ))}

          {!this.isResultEmpty && (
            <PaginationComponent
              currentPage={this.props.currentPage}
              dataCount={this.dataCount}
              firstElement={this.firstElement}
              lastElement={this.lastElement}
              onNextPageClick={this.handleNextPage}
              onPreviousPageClick={this.handlePreviousPage}
            />
          )}
        </section>
      </div>
    );
  }
}

export default SearchResultsTable;



// WEBPACK FOOTER //
// ./src/components/AdvancedSearch/SearchResults/SearchResultsTable.js